// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  margin-bottom: 50px;
}

.App-logo {
  height: 30vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  //background-color: #282c34;
  min-height: 35vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.App-pre {
    text-align: left;
}


@keyframes App-logo-spin {
  from {
    transform: rotateY(0);
  }
  to {
    transform: rotateY(360deg);
  }
}

/*
@keyframes App-logo-spin {
  50%, 100% {
    transform: rotateY(360deg);
  }
}
*/

@keyframes App-logo-spin {
    0% {
        transform: rotateY(0);
    }
    2%,50% {
        transform: rotateY(180deg);
    }
    52%, 100% {
    transform: rotateY(360deg);
  }
}

.footer {
 background-color: #bdbdbd;
 border-top: 2px solid #66bb6a;
 position: fixed;
 width: 100%;
 bottom: 0;
 color: white;
 font-size: 15px;
}

.md-wrapper { margin-left: 10em; margin-right: 10em; }
@media (max-width: 900px) { .md-wrapper { margin-left: 4em; margin-right: 4em; } }
@media (max-width: 600px) { .md-wrapper { margin-left: 1em; margin-right: 1em; } }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;;;;CAMC;;AAED;IACI;QACI,qBAAqB;IACzB;IACA;QACI,0BAA0B;IAC9B;IACA;IACA,0BAA0B;EAC5B;AACF;;AAEA;CACC,yBAAyB;CACzB,6BAA6B;CAC7B,eAAe;CACf,WAAW;CACX,SAAS;CACT,YAAY;CACZ,eAAe;AAChB;;AAEA,cAAc,iBAAiB,EAAE,kBAAkB,EAAE;AACrD,4BAA4B,cAAc,gBAAgB,EAAE,iBAAiB,EAAE,EAAE;AACjF,4BAA4B,cAAc,gBAAgB,EAAE,iBAAiB,EAAE,EAAE","sourcesContent":[".App {\n  text-align: center;\n  margin-bottom: 50px;\n}\n\n.App-logo {\n  height: 30vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  //background-color: #282c34;\n  min-height: 35vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.App-pre {\n    text-align: left;\n}\n\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotateY(0);\n  }\n  to {\n    transform: rotateY(360deg);\n  }\n}\n\n/*\n@keyframes App-logo-spin {\n  50%, 100% {\n    transform: rotateY(360deg);\n  }\n}\n*/\n\n@keyframes App-logo-spin {\n    0% {\n        transform: rotateY(0);\n    }\n    2%,50% {\n        transform: rotateY(180deg);\n    }\n    52%, 100% {\n    transform: rotateY(360deg);\n  }\n}\n\n.footer {\n background-color: #bdbdbd;\n border-top: 2px solid #66bb6a;\n position: fixed;\n width: 100%;\n bottom: 0;\n color: white;\n font-size: 15px;\n}\n\n.md-wrapper { margin-left: 10em; margin-right: 10em; }\n@media (max-width: 900px) { .md-wrapper { margin-left: 4em; margin-right: 4em; } }\n@media (max-width: 600px) { .md-wrapper { margin-left: 1em; margin-right: 1em; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
